import { render, staticRenderFns } from "./MasterDataDrugs.vue?vue&type=template&id=34116542&scoped=true"
import script from "./MasterDataDrugs.vue?vue&type=script&lang=js"
export * from "./MasterDataDrugs.vue?vue&type=script&lang=js"
import style0 from "./MasterDataDrugs.vue?vue&type=style&index=0&id=34116542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34116542",
  null
  
)

export default component.exports